<template>
    <div>
        <PageTitle :title="faq.title"/>
        <FirstBanner />
        <div v-if="!loading" class="container py-4">
            <div class="d-flex flex-column">
                <div v-html="faq.description"></div>
                <b-button :to="{ name: 'front.faqs.index' }" class="ml-auto">Volver</b-button>
            </div>
        </div>
        <LoaderComponent v-else/>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle'
    import FirstBanner from '@/components/frontend/shared/FirstBanner'
    import LoaderComponent from "@/components/preloader/LoaderComponent";
    import { useHead } from '@/composables/common/seo/useHead';

    export default {
        components: {
            PageTitle,
            FirstBanner,
            LoaderComponent
        },
        props: ['faq_id'],
        data() {
            return {
                faq: '',
                loading: false,
            }
        },
        created() {
            useHead('Detalle de una pregunta');
            this.getFaq()
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig
            },
            manager() {
                return this.$store.getters.getFooter
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            getFaq() {
                this.loading = true
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        tipo: this.manager.tipo === 1 ? 'deportivo' : 'teatro',
                    },
                    faq_id: this.faq_id,
                }

                this.$store
                    .dispatch(this.config.getVuexAlias('front.faqs.show'), params)
                    .then(res => {
                        this.faq = res.data.data
                        this.loading = false
                    })
                    .catch(error => {
                        this.$router.push({ name: 'front.faqs.index' })
                        console.log(error)
                        this.loading = false
                    })
            },
        },
    }
</script>
